const initialState = {
    pending: true,
	logged: false,
	loginToken: '',
	profileLoaded: false
};

const loggedUserReducer = (state = initialState, action) => {
	
    if (action.type === 'GET_LOGGED_USER') {
		return Object.assign({}, state, {
			pending: false,
			loginToken: action.loginToken
		});
    }
    if (action.type === 'SET_LOGGED_USER') {
		return Object.assign({}, state, {
			pending: false,
			logged: action.logged
		});
	}
	if (action.type === 'LOGGED_STATE') {
		return Object.assign({}, state, {
			pending: false,
			logged: action.logged
		});
	}
	if (action.type === 'USER_PROFILE_DATA') {
		return Object.assign({}, state, {
			prefData: action.prefData
		});
	}
	if (action.type === 'USER_ROLE_INFO' ) {
		return Object.assign({}, state, {
			userRole: action.userRole
		});
	}
	if(action.type === 'LOAD_PROFILE_DATA') {
		return Object.assign({}, state, {
			profileLoaded: action.profileLoaded
		});
	}

	if (action.type === 'SET_USER_PREFERENCES') {
		return Object.assign({}, state, {
			prefData: {
				profile: state.prefData.profile,
				preferences: action.preferences
			}
		});
	}

    return state;
};

export default loggedUserReducer;


// WEBPACK FOOTER //
// ./src/reducers/loggedUserReducer.js